import { combineReducers } from "redux";
import { classificationConstants } from "../../actions/documents/classification";
const defaultStateObj = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function typesDocuments(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        types: null,
        status: { error: false, started: false, ended: false }
      }
      : state;
  switch (type) {
  case classificationConstants.GET_TYPES_SUCCESS:
    return {
      types: payload,
      status: { error: false, started: false, ended: true }
    };
  case classificationConstants.GET_TYPES_ERROR:
    return { status: { error: true, started: false, ended: false } };
  case classificationConstants.GET_TYPES_START:
    return {
      types: null,
      status: { error: false, started: true, ended: false }
    };
  default:
    return defaultState;
  }
}

function statusClassification(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? defaultStateObj : state;
  switch (type) {
  case classificationConstants.SAVE_CLASSIFICATION_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload.code,
          message: payload.message
        }
      }
    };
  case classificationConstants.SAVE_CLASSIFICATION_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false,
        errorInfo: {
          code: "",
          message: ""
        }
      }
    };
  case classificationConstants.SAVE_CLASSIFICATION_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true,
        errorInfo: {
          code: "",
          message: ""
        }
      }
    };
  case classificationConstants.RESET_CLASSIFICATION:
    return {
      status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
          code: "",
          message: ""
        }
      }
    };
  default:
    return defaultState;
  }
}

export const classification = combineReducers({
  statusClassification,
  typesDocuments
});

export default classification;
